import type { ScreenModule } from "../../../app/screen-module";
import { ContactPage } from "../auth-pages";

export default {
	id: "public.contact",
	path: "/contact",
	area: "public",
	label: "お問い合わせ",
	roles: [],
	backing: "MOCK_ONLY",
	enabled: true,
	component: ContactPage,
} satisfies ScreenModule;
